import ApiService from './ApiService'

export const apiSignIn = (data) => ApiService.post('/users/sign_in', data)
export const apiUserDetails = () => ApiService.get('/threepl/get-user-details')
export const apiSignOut = () => ApiService.get('/users/sign_out')
export const apiForgotPassword = (data) =>
    ApiService.put('/users/wshed/reset-password', data)
export const apiResetPassword = (data) =>
    ApiService.post('/users/set_password', data)
